import { render, staticRenderFns } from "./InputFileCustom.vue?vue&type=template&id=22f45bac&scoped=true&"
import script from "./InputFileCustom.vue?vue&type=script&lang=js&"
export * from "./InputFileCustom.vue?vue&type=script&lang=js&"
import style0 from "./InputFileCustom.vue?vue&type=style&index=0&id=22f45bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f45bac",
  null
  
)

export default component.exports